var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.option === 1)?_c('CardAgregarVotante'):_vm._e(),(_vm.option === 2)?_c('CardVotantePuesto'):_vm._e(),(_vm.option === 3)?_c('CardGestionVotantes'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }